import React from "react";
import Button from "../components/common/Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import FeatureCard from "../components/common/FeatureCard/FeatureCard";
import Field from "../components/common/Field/Field";
import Fi from "../components/common/Field/Fi";
import Buy from "../assets/svgs/Buy.svg";
import Pro from "../assets/svgs/Pro.svg";
import CheckIcon from "@mui/icons-material/Check";
import Auction from "../assets/svgs/Auction.svg";
import MenuItem from "@mui/material/MenuItem";
import {
  Typography,
  Checkbox,
  FormControl,
  FormControlLabel,
  Box,
  Divider,
} from "@mui/material";
import Menu from "../components/common/Menu/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import { Container } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Note from "../components/common/Note/Note";
import SnackbarHandler from "../components/common/Snackbar/SnackbarHandler";
import Tooltip from "../components/common/Tooltip/Tooltip";
import ListingCard from "../components/common/ListingCard/ListingCard";
import Ellipse from "../components/common/GalleryComponent/Ellipse";
import Play from "../components/common/GalleryComponent/Play";
import Swipe from "../components/common/GalleryComponent/Swipe";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function ReuseableComponents() {
  const [val, setVal] = React.useState("");
  const handleChange = (event) => {
    setVal(event.target.value);
  };
  return (
    <div>
      <Container sx={{ display: "flex", columnGap: "24px", margin: "20px 0" }}>
        <Button
          bgColor="#F9D548"
          variant="contained"
          size="lg"
          txColor="#1F1F1F"
          sx={{ boxShadow: "none" }}
        >
          Label
        </Button>

        <Button
          bgColor="#F3C04F"
          variant="contained"
          size="lg"
          txColor="#1F1F1F"
          sx={{ boxShadow: "none" }}
        >
          Label
        </Button>
        <Button
          bgColor="#F9D548"
          variant="contained"
          txColor="#1F1F1F"
          sx={{ boxShadow: "none", height: "36px", width: "69px" }}
        >
          Label
        </Button>
        <Button
          bgColor="#F3C04F"
          variant="contained"
          txColor="#1F1F1F"
          sx={{ boxShadow: "none", height: "36px", width: "69px" }}
        >
          Label
        </Button>
      </Container>
      <Container sx={{ display: "flex", columnGap: "24px", margin: "20px 0" }}>
        <Button
          variant="outlined"
          sx={{
            backgroundColor: "#255CCE1A",
            borderColor: "#255CCE",
            padding: "8px",
            height: "36px",
          }}
          size="lg"
          txColor="text.primary"
          typoVariant="body1"
          fontWeight="400"
          endIcon={
            <CloseIcon
              sx={{ color: "text.primary", width: "16px", height: "16px" }}
            />
          }
        >
          Label
        </Button>

        <Button
          variant="standard"
          sx={{
            backgroundColor: "#F5F5F5",
            padding: "8px",
            height: "36px",
          }}
          size="lg"
          txColor="text.primary"
          typoVariant="body1"
          fontWeight="400"
        >
          Label
        </Button>

        <Button
          variant="outlined"
          sx={{
            backgroundColor: "#255CCE1A",
            borderColor: "#255CCE",
            padding: "8px",
            height: "36px",
          }}
          size="lg"
          txColor="text.primary"
          typoVariant="body1"
          fontWeight="400"
          startIcon={
            <DoneIcon
              sx={{ color: "text.primary", width: "16px", height: "16px" }}
            />
          }
        >
          Label
        </Button>

        <Button
          variant="outlined"
          sx={{
            backgroundColor: "#255CCE1A",
            borderColor: "#255CCE",
            padding: "8px",
            height: "36px",
          }}
          size="lg"
          txColor="text.primary"
          typoVariant="body1"
          fontWeight="400"
        >
          Label
        </Button>
      </Container>
      <Container sx={{ display: "flex", margin: "20px 0px" }}>
        <FeatureCard
          img={Buy}
          cardTitle="Headline"
          cardDesc="label"
          cardActionText="Button"
        />
      </Container>
      <Container
        sx={{
          display: "flex",
          margin: "20px 0px",
          justifyContent: "space-between",
        }}
      >
        <Fi
          height="46.29px"
          label="Label"
          value={val}
          handleChange={handleChange}
          endIcon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
        />
        {/* <Field
          label="Label"
          error={true}
          helperText="Error"
          icon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
        />
        <Field
          label="Label"
          icon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
          bordColor="#CFCFCF"
        />
        <Field
          label="Label"
          icon={<KeyboardArrowDownIcon sx={{ color: "#808080" }} />}
          bordColor="#2D2D2D"
        /> */}
      </Container>
      <Container
        sx={{
          display: "flex",
          margin: "100px 0px",
          justifyContent: "space-between",
        }}
      >
        <Menu
          text="Make and models"
          textVariant="subtitle2"
          buttonStyle={{ width: "426px", height: "40px", padding: "0px" }}
          textStyle={{ color: "text.primary" }}
          buttonVariant="outlined"
          icons={[<ArrowDropDownIcon />]}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          paperStyle={{
            width: "426px",
            maxHeight: "440px",
            borderRadius: "4px",
            marginTop: "10px",
          }}
        >
          <MenuItem
            sx={{
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
          >
            <Field
              label="Search Currency"
              borderColor="#DFDFDF"
              width="100%"
              endIcon={<SearchIcon sx={{ color: "#808080" }} />}
            ></Field>
          </MenuItem>
          <MenuItem
            sx={{
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
          >
            <Typography
              variant="caption"
              fontWeight="400"
              fontSize="12px"
              lineHeight="16px"
              color="#616161"
              sx={{ marginTop: "25px" }}
            >
              Makes
            </Typography>
          </MenuItem>

          <Box>
            <MenuItem sx={{ paddingY: "0px", marginBottom: "6px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    // checked={checked}
                    // onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{
                      paddingY: "0px",
                      "& .MuiSvgIcon-root": { fontSize: 16 },
                      // color: "#6200EE",
                      "&.Mui-checked": {
                        color: "#6200EE",
                      },
                    }}
                  />
                }
                checked={true}
                label={
                  <Typography
                    sx={{ fontSize: "16px", lineHeight: "24px" }}
                    variant="body1"
                  >
                    All
                  </Typography>
                }
              />
            </MenuItem>
          </Box>
          <Divider />
          <MenuItem>
            <Container
              disableGutters={true}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", columnGap: "8px" }}
              >
                <CheckIcon
                  sx={{ width: "16px", height: "16px", color: "#616161" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#616161",
                  }}
                >
                  5 Selected
                </Typography>
              </Box>
              <Button
                sx={{ padding: "0px", minWidth: "fit-content" }}
                variant="text"
              >
                Reset
              </Button>
            </Container>
          </MenuItem>
        </Menu>
      </Container>
      <Container
        sx={{
          display: "flex",
          margin: "20px 0px",
          justifyContent: "space-between",
        }}
      >
        <Note sx={{ width: "313px", height: "52px" }} label="Note Text" />
        <SnackbarHandler />
        <Tooltip title="Label" placement="left" label="Tooltip" />
      </Container>
      <Container
        sx={{
          display: "flex",
          margin: "20px 0px",
          justifyContent: "space-between",
        }}
      >
        <ListingCard />
      </Container>
      <Container
        sx={{
          display: "flex",
          margin: "20px 0px",
          justifyContent: "space-between",
        }}
      >
        <Ellipse />
        <Play />
        <Swipe />
      </Container>
    </div>
  );
}

export default ReuseableComponents;
